export const TABLES_FIREBASE = {
	transactions: "transactions",
	customer: "customer",
	contract: "contract",
	catalog_exports: "catalog_exports",
	candidatures: "candidaturas_revendedoras"
};


